{
  "title": "تعذر إتمام تسجيل دخولك",
  "message": "تعذر التحقق من هويتك"
}
